// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ShippingDetailsSection-module-viewContainer-9XN4o{display:grid;grid-gap:20px;gap:20px;grid-template-columns:auto;margin-bottom:24px;opacity:.5}@media(min-width: 960px){.ShippingDetailsSection-module-viewContainer-9XN4o{grid-template-columns:auto auto}}.ShippingDetailsSection-module-contactData-m92QP{display:grid;grid-gap:4px;gap:4px}.ShippingDetailsSection-module-title-rUew8{color:#373a36;font-size:26px;font-weight:var(--weight-light);letter-spacing:0;line-height:23px;padding-block:24px;padding-inline:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"viewContainer": "ShippingDetailsSection-module-viewContainer-9XN4o",
	"contactData": "ShippingDetailsSection-module-contactData-m92QP",
	"title": "ShippingDetailsSection-module-title-rUew8"
};
export default ___CSS_LOADER_EXPORT___;
